var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("CenterForSorting.changeCompareTitle"),
        visible: _vm.dialogVisible,
        width: "760px",
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-table",
        {
          staticClass: "change-compare-table",
          attrs: {
            data: _vm.compareRows,
            border: "",
            size: "small",
            "header-cell-style": { background: "#f5f7fa", color: "#303133" },
            "max-height": "520",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "field",
              label: _vm.$t("CenterForSorting.changeField"),
              "min-width": "220",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "beforeValue",
              label: _vm.$t("CenterForSorting.beforeData"),
              "min-width": "240",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "afterValue",
              label: _vm.$t("CenterForSorting.afterData"),
              "min-width": "240",
            },
          }),
        ],
        1
      ),
      _vm.compareRows.length === 0
        ? _c("div", { staticClass: "empty-wrap" }, [
            _vm._v(
              " " + _vm._s(_vm.$t("CenterForSorting.noChangeLogData")) + " "
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }